import React, { useEffect, useState } from "react";
import { Link, usePage } from '@inertiajs/react'
import clsx from "clsx";

const baseClass = 'p-2 w-[40px] h-[40px] border text-center flex justify-center items-center';
const hoverClass = 'hover:bg-gray-100';

const getUrl = (url, page) => {
    return url + '?page=' + page;
}

export default function Pagination({ page, total, route, callback }) {
    const { appName } = usePage().props

    const click: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
        if (callback !== undefined) {
            event.preventDefault()

            const page = (event.target as HTMLAnchorElement).getAttribute('data-page')

            console.log(event.target)

            callback(Number(page))

        }
    }

    useEffect(() => {
        console.log(page, total)
    }, [page, total])


    return (
        <ul className="flex gap-1 flex-between">
            {page > 1 ? (<li className="flex justify-center">
                <a className={clsx([baseClass, hoverClass])} data-page={page - 1} onClick={click} href={getUrl(route, page - 1)}>{'<'}</a>
            </li>) : null}

            {page != 1 ? (<li className="flex justify-center">
                <a className={clsx([baseClass, hoverClass])} data-page={1} onClick={click} href={getUrl(route, 1)}>1</a>
            </li>) : null}

            {page > 4 ? (<li className="flex justify-center">
                <span className={clsx([baseClass, hoverClass])}>...</span>
            </li>) : null}

            {page - 2 > 1 ? (<li className="flex justify-center">
                <a className={clsx([baseClass, hoverClass])} data-page={page - 2} onClick={click} href={getUrl(route, page - 2)}>{page - 2}</a>
            </li>) : null}

            {page - 1 > 1 ? (<li className="flex justify-center">
                <a className={clsx([baseClass, hoverClass])} data-page={page - 1} onClick={click} href={getUrl(route, page - 1)}>{page - 1}</a>
            </li>) : null}

            <li className="flex justify-center">
                <span className={clsx([baseClass, 'bg-blue-500 text-white'])}>{page}</span>
            </li>

            {page + 1 < total ? (<li className="flex justify-center">
                <a className={clsx([baseClass, hoverClass])} data-page={page + 1} onClick={click} href={getUrl(route, page + 1)}>{page + 1}</a>
            </li>) : null}

            {page + 2 < total ? (<li className="flex justify-center">
                <a className={clsx([baseClass, hoverClass])} data-page={page + 2} onClick={click} href={getUrl(route, page + 2)}>{page + 2}</a>
            </li>) : null}

            {page + 3 < total ? (<li className="flex justify-center">
                <span className={baseClass}>...</span>
            </li>) : null}

            {page !== total ? (<li className="flex justify-center">
                <a className={clsx([baseClass, hoverClass])} data-page={total} onClick={click} href={getUrl(route, total)}>{total}</a>
            </li>) : null}

            {page < total ? (<li className="flex justify-center">
                <a className={clsx([baseClass, hoverClass])} data-page={page + 1} onClick={click} href={getUrl(route, page + 1)}>{'>'}</a>
            </li>) : null}
        </ul>
    )
}